import React from "react";
import SectionHeader from "./SectionHeader";
import RVEOModality from "./RVEOModality";
import { RVEOModalitySimulation } from "../../../../interfaces/rveoSimulations";

interface RVEOModalitiesSectionProps {
  modalities: RVEOModalitySimulation[];
}

const RVEOModalitiesSection: React.FC<RVEOModalitiesSectionProps> = ({
  modalities,
}) => {
  if (!modalities || modalities.length === 0) return null;

  return (
    <>
      <SectionHeader title="Modalidades" style={{ marginTop: "16px" }} />
      {modalities.map((modality, index) => (
        <RVEOModality
          key={index}
          modality={modality}
          isLast={index === modalities.length - 1}
        />
      ))}
    </>
  );
};

export default RVEOModalitiesSection;
